import React, { useEffect } from 'react';
import Routes from './routes';
import Legal from './pages/Legal/Legal';
import { HelmetProvider } from 'react-helmet-async';
import RGPD from './components/Common/RGPD/RGPD';

const App: React.FC = () => {
  useEffect(() => {
    // Gestionnaire d'erreurs global pour les promesses non gérées
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('🚨 Promesse rejetée non gérée:', event.reason);
      console.error('🚨 Stack trace:', event.reason?.stack);
      
      // Empêcher l'affichage de l'erreur par défaut dans la console
      // event.preventDefault();
    };

    // Gestionnaire d'erreurs global pour les erreurs JavaScript
    const handleError = (event: ErrorEvent) => {
      console.error('🚨 Erreur JavaScript globale:', event.error);
      console.error('🚨 Message:', event.message);
      console.error('🚨 Fichier:', event.filename);
      console.error('🚨 Ligne:', event.lineno);
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <Routes />
        <RGPD privacyPolicyUrl="/legal" />
      </div>
    </HelmetProvider>
  );
};

export default App;
